"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTooltip = useTooltip;
const react_1 = require("@floating-ui/react");
const react_2 = require("react");
function useTooltip(options) {
    var _a, _b;
    const [open, setOpen] = (0, react_2.useState)(false);
    const data = (0, react_1.useFloating)({
        middleware: [
            (0, react_1.offset)((_a = options.offset) !== null && _a !== void 0 ? _a : 16),
            (0, react_1.flip)(),
            (0, react_1.shift)({ padding: (_b = options.shiftPadding) !== null && _b !== void 0 ? _b : 8 }),
            (0, react_1.arrow)({ element: options.arrowRef }),
        ],
        open,
        onOpenChange: setOpen,
        placement: options.placement,
        whileElementsMounted: (reference, floating, update) => (0, react_1.autoUpdate)(reference, floating, update, {
            elementResize: typeof ResizeObserver !== "undefined",
        }),
    });
    const context = data.context;
    const hover = (0, react_1.useHover)(context, { delay: 200, handleClose: (0, react_1.safePolygon)(), move: false });
    const focus = (0, react_1.useFocus)(context);
    const role = (0, react_1.useRole)(context, { role: "tooltip" });
    const dismiss = (0, react_1.useDismiss)(context);
    const interactions = (0, react_1.useInteractions)([hover, focus, dismiss, role]);
    return (0, react_2.useMemo)(() => ({
        open,
        setOpen,
        ...interactions,
        ...data,
    }), [open, setOpen, interactions, data]);
}
